let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '公告配置ID',
        props: 'anNo',
        minWidth: 220,
    },
    {
        label: '公告名称',
        props: 'anName',
        minWidth: 200,
    },
    {
        label: '公告内容',
        props: 'content',
        minWidth: 200,
    },
    {
        label: '启用时间',
        props: 'startTime',
        minWidth: 180,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 150,
    },
    {
        label: '启用状态',
        props: 'statusName',
        minWidth: 180,
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 180,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 180,
    },
    {
        label: '更新人',
        props: 'lastModifiedByName',
        minWidth: 180,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理'
    },
    {
        type: 'title',
        name: '公告栏配置'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};
pageConfig.logBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '广告位配置',
    },
    {
        type: 'title',
        name: '更新记录'
    }
];
pageConfig.historyBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '广告位配置',
    },
    {
        type: 'title',
        name: '历史查看'
    }
];
// 路由
pageConfig.listRouter = 'announcementBoardConfiguration';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '运营配置',
    },
    {
        type: 'title',
        name: '广告位管理',
       
    },
    {
        type: 'router',
        name: '公告栏配置',
        router: 'announcementBoardConfiguration'
    },
    {
        type: 'title',
        name: '公告栏详情'
    }
];


pageConfig.formRules = {
    anName: [{ required: true, message: '请输入公告名称', trigger: 'blur' }],
    content: [{ required: true, message: '请输入公告内容', trigger: 'blur' }],
    startTime: [{ required: true, message: '请选择启用时间', trigger: 'change' }],
    endTimeType: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
    url: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
};



export default pageConfig;
